import { Header } from '@/components/Header';
import { WithLoader } from '@/components/WithLoader';
import { ReportItem } from '@/dashboards/Reports/ReportItem';
import { ReportPreviewModal } from '@/dashboards/Reports/ReportPreviewModal';
import { useReportsQuery } from '@/dashboards/Reports/hooks/useReportsQuery';
import { ReportsProvider } from '@/dashboards/Reports/providers';

export const Reports = () => {
    const { reports, isLoading, isFetching } = useReportsQuery();

    const hasReports = !isLoading && reports && reports?.length > 0;

    return (
        <ReportsProvider>
            <Header className="pb-6 px-16 pt-6" title="Reports" />

            <div className="pb-8 px-16">
                <WithLoader isLoading={isLoading} isFetching={isFetching}>
                    <div className="flex flex-row gap-8 h-full ">
                        <div className="flex flex-col gap-4 w-full xl:flex-row ">
                            <div className="flex flex-col h-full w-6/12 max-2xl:w-full glass-tile p-6 gap-4">
                                {reports?.map((report) => (
                                    <ReportItem
                                        key={report.id}
                                        report={report}
                                    />
                                ))}

                                {!hasReports && (
                                    <div className="flex flex-col items-center justify-center">
                                        No reports found
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                    <ReportPreviewModal />
                </WithLoader>
            </div>
        </ReportsProvider>
    );
};
